<app-header-client></app-header-client>
<app-loader *ngIf="loading"></app-loader>
<div id="ContainerCategories">
    <div id="ContainerCategorie">
        <p *ngFor="let categorie of  nomCategories"><span (click)="SetCategorie(categorie,true)">{{categorie}}</span>
        </p>
    </div>

    <img id="LogoBoutiqueMemorial" src="../../../assets/Utilisateur/LogoBoutiqueMemorial.png">
</div>